export default "__VITE_ASSET__DmMjjxOe__"